import styles from "./CustomerApproval.module.scss";
import { UploadDocType } from "../JobLead/constants";
import CreateJobServices from "../../../../services/createJob.services";
import CustomerApprovalUploadDragger from "./CustomerApprovalUploadDragger";
import {
  CustomerApprovalConstants,
  customerApprovalStatusMessages,
} from "./constants";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { jobStatus } from "../constants";

const { HEADER, OR_TEXT, UPLOAD_TEXT } = CustomerApprovalConstants;

const CustomerApproval = ({
  handleCustomerApprovedFiles,
  leadId,
  editable,
}) => {
  const { quoteDoc } = UploadDocType;
  const { FetchAllDocuments, FetchSelectedJob } = CreateJobServices();
  const location = useLocation();
  const currentLeadId = editable
    ? location?.pathname?.split("/")?.at(-1)
    : leadId;
  const { data: documentsData } = FetchAllDocuments(currentLeadId);
  const { data } = FetchSelectedJob(currentLeadId);
  const [filteredDocuments, setFilteredDocuments] = useState(
    documentsData
      ?.filter((doc) => doc.signatureVerified)
      ?.map((doc) => ({
        ...doc,
        name: doc.name || doc.docAttachmentId.replace("quotes/", ""),
      }))
  );

  const [approvalStatus, setApprovalStatus] = useState(
    data?.stageId === jobStatus.quoteShared
      ? HEADER
      : filteredDocuments?.length
      ? customerApprovalStatusMessages.Approved
      : HEADER
  );

  useEffect(() => {
    setFilteredDocuments(
      documentsData
        ?.filter((doc) => doc.signatureVerified)
        ?.map((doc) => ({
          ...doc,
          name: doc.name || doc.docAttachmentId.replace("quotes/", ""),
        }))
    );
  }, [documentsData, currentLeadId]);

  useEffect(() => {
    setApprovalStatus(
      data?.stageId === jobStatus.quoteShared
        ? HEADER
        : filteredDocuments?.length
        ? customerApprovalStatusMessages.Approved
        : HEADER
    );
  }, [filteredDocuments]);
  return (
    <div className={styles.CustomerApprovalContainer}>
      <div>
        <h1>{approvalStatus}</h1>
        <p>{OR_TEXT}</p>
      </div>
      <div className={styles.UploadContainer}>
        <p>{UPLOAD_TEXT}</p>
        <CustomerApprovalUploadDragger
          handleFileUpload={handleCustomerApprovedFiles}
          fileType={quoteDoc}
          listOfUploadedFiles={filteredDocuments}
          key={quoteDoc}
          maxFileSize={20}
        />
      </div>
    </div>
  );
};
export default CustomerApproval;
